import $$ from '@/store/plugins/storage'
import vue from 'vue'

// const namespace = 'table'
// $$.setNamespace(namespace)

// const state = {
//   // 分页的每页条数
//   pageSizeOpts: [10, 20, 50, 100],
//   // 列表的筛选列
//   columnsCheckedAll: $$.get('columnsCheckedAll') || {},
//   isShowApproveBtn: true
// }

// const mutations = {
//   _columnsCheckedAll(state, value) {
//     for (let key in value) {
//       vue.set(state.columnsCheckedAll, key, value[key])
//     }
//   },
//   _pageSizeOpts(state, value) {
//     state.pageSizeOpts = value
//   },
//   _isShowApproveBtn(state, value) {
//     state.isShowApproveBtn = value
//   }
// }

const namespace = 'table'
$$.setNamespace(namespace)

const state = {
  // 分页的每页条数
  pageSizeOpts: [10, 20, 50, 100],
  // 列表的筛选列
  columnsCheckedAll: $$.get('columnsCheckedAll') || {},
  tempsLocalStore: $$.get('tempsLocalStore') || {},
  searchFormlist: {},
  isShowApproveBtn: true
}

const mutations = {
  _columnsCheckedAll(state, value) {
    for (let key in value) {
      vue.set(state.columnsCheckedAll, key, value[key])
    }
  },
  _pageSizeOpts(state, value) {
    state.pageSizeOpts = value
  },
  _tempsLocalStore(state, { key, value }) {
    vue.set(state.tempsLocalStore, key, value)
  },
  _searchFormlist(state, value) {
    state.searchFormlist = value
  },
  _isShowApproveBtn(state, value) {
      state.isShowApproveBtn = value
    }
}

export default { namespaced: true, state, mutations }



// WEBPACK FOOTER //
// ./src/store/modules/table.js